import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Locale resources
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enNav from './locales/en/nav.json';
import enAlerts from './locales/en/alerts.json';
import enErrors from './locales/en/errors.json';
import enUsers from './locales/en/users.json';
import enReports from './locales/en/reports.json';
import enTraining from './locales/en/training.json';
import enAccount from './locales/en/account.json';
import enSupport from './locales/en/support.json';
import enAbout from './locales/en/about.json';
import enFaqs from './locales/en/faqs.json';
import enUserManual from './locales/en/userManual.json';
import enMfa from './locales/en/mfa.json';
import enPage404 from './locales/en/page404.json';
import enPatients from './locales/en/patients.json';
import enOnboarding from './locales/en/onboarding.json';

import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esNav from './locales/es/nav.json';
import esAlerts from './locales/es/alerts.json';
import esErrors from './locales/es/errors.json';
import esUsers from './locales/es/users.json';
import esReports from './locales/es/reports.json';
import esTraining from './locales/es/training.json';
import esAccount from './locales/es/account.json';
import esSupport from './locales/es/support.json';
import esAbout from './locales/es/about.json';
import esFaqs from './locales/es/faqs.json';
import esUserManual from './locales/es/userManual.json';
import esMfa from './locales/es/mfa.json';
import esPage404 from './locales/es/page404.json';
import esPatients from './locales/es/patients.json';
import esOnboarding from './locales/es/onboarding.json';

import ptCommon from './locales/pt/common.json';
import ptAuth from './locales/pt/auth.json';
import ptNav from './locales/pt/nav.json';
import ptAlerts from './locales/pt/alerts.json';
import ptErrors from './locales/pt/errors.json';
import ptUsers from './locales/pt/users.json';
import ptReports from './locales/pt/reports.json';
import ptTraining from './locales/pt/training.json';
import ptAccount from './locales/pt/account.json';
import ptSupport from './locales/pt/support.json';
import ptAbout from './locales/pt/about.json';
import ptFaqs from './locales/pt/faqs.json';
import ptUserManual from './locales/pt/userManual.json';
import ptMfa from './locales/pt/mfa.json';
import ptPage404 from './locales/pt/page404.json';
import ptPatients from './locales/pt/patients.json';
import ptOnboarding from './locales/pt/onboarding.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        nav: enNav,
        alerts: enAlerts,
        errors: enErrors,
        users: enUsers,
        reports: enReports,
        training: enTraining,
        account: enAccount,
        support: enSupport,
        about: enAbout,
        faqs: enFaqs,
        userManual: enUserManual,
        mfa: enMfa,
        page404: enPage404,
        patients: enPatients,
        onboarding: enOnboarding,
      },
      es: {
        common: esCommon,
        auth: esAuth,
        nav: esNav,
        alerts: esAlerts,
        errors: esErrors,
        users: esUsers,
        reports: esReports,
        training: esTraining,
        account: esAccount,
        support: esSupport,
        about: esAbout,
        faqs: esFaqs,
        userManual: esUserManual,
        mfa: esMfa,
        page404: esPage404,
        patients: esPatients,
        onboarding: esOnboarding,
      },
      pt: {
        common: ptCommon,
        auth: ptAuth,
        nav: ptNav,
        alerts: ptAlerts,
        errors: ptErrors,
        users: ptUsers,
        reports: ptReports,
        training: ptTraining,
        account: ptAccount,
        support: ptSupport,
        about: ptAbout,
        faqs: ptFaqs,
        userManual: ptUserManual,
        mfa: ptMfa,
        page404: ptPage404,
        patients: ptPatients,
        onboarding: ptOnboarding,
      },
    },
    // Default namespace used when no namespace is specified
    defaultNS: 'common',
    // Fallback language when a key is missing in the active language
    fallbackLng: 'en',
    // Detection config: check localStorage first, then browser language
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      // React already escapes values by default
      escapeValue: false,
    },
  });

// Sync i18next language changes back to Redux.
// Dynamic imports prevent circular dependency issues since this module is
// evaluated before the Redux store is initialized on first load.
i18n.on('languageChanged', (lng) => {
  Promise.all([
    import('../redux/store'),
    import('../redux/store/i18nSlice'),
  ])
    .then(([{ default: store }, { setLanguage }]) => {
      store.dispatch(setLanguage(lng));
    })
    .catch(() => {
      // Silently ignore — Redux store may not be ready on first initialization
    });
});

export default i18n;
